exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cart-item .sub-checkbox .mr-checkbox {\n  width: 16px;\n  height: 16px;\n}\n.cart-item .sub-checkbox .mr-checkbox.selected:before {\n  font-size: 13px;\n  line-height: 15px;\n  width: 15px;\n  height: 15px;\n}\n", ""]);

// exports
